import { axiosInstance } from '../../../api';
const BASE_PATH = '/common';


//Get All CV Reviewers API Call
export let sendBulkEmailsToCandidates = async (candidate_id_list, email_subject, email_body) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/send_bulk_emails_to_candidates', {
            candidate_id_list: candidate_id_list,
            email_subject: email_subject,
            email_body: email_body
        })
        return value;
    } catch (error) {
        return error
    }
}